import React, { useContext } from 'react';
import { CalculatorCurrency } from '../../../shared/components/CalculatorCurrency';
import { useCalculatorNavigate } from '../../../shared/utils/calculatorNavigate';
import { CalculatorHtmModeContext, CalculatorRedirectHomeContext } from '../../../shared/contexts/CalculatorContext';
import { CalculatorHTMMode } from '../../../shared/classes/CalculatorMode';

export function CalculatorHome(): JSX.Element {
    const navigate = useCalculatorNavigate();
    const calculatorModeContext = useContext(CalculatorHtmModeContext)!;
    const calculatorRedirectHomeContext = useContext(CalculatorRedirectHomeContext)!;

    const navigateToEconomical = (mode: CalculatorHTMMode) => {
        calculatorModeContext[1](mode);
        calculatorRedirectHomeContext[1](false);
        navigate('clinical-examinations');
    }

    return (
        <div className="home">

            <section>

                <div> <CalculatorCurrency/></div>

                <div>
                    <a onClick={() => navigateToEconomical(CalculatorHTMMode.Direct)}>GE HealthCare direct</a>
                    <a onClick={() => navigateToEconomical(CalculatorHTMMode.HTM)}> HTM's</a>
                </div>

            </section>

            <section>

            </section>

        </div>
    );
}
